import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getItemElement as $feb5ffebff200149$export$c3d8340acf92597f } from "./utils.module.js";
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $657e4dc4a6e88df0$export$8f5ed9ff9f511381 = /*#__PURE__*/function () {
  function $657e4dc4a6e88df0$export$8f5ed9ff9f511381(ref) {
    _classCallCheck(this, $657e4dc4a6e88df0$export$8f5ed9ff9f511381);

    this.ref = ref;
  }

  return _createClass($657e4dc4a6e88df0$export$8f5ed9ff9f511381, [{
    key: "getItemRect",
    value: function getItemRect(key) {
      var container = this.ref.current;
      if (!container) return null;
      var item = key != null ? (0, $feb5ffebff200149$export$c3d8340acf92597f)(this.ref, key) : null;
      if (!item) return null;
      var containerRect = container.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      return {
        x: itemRect.left - containerRect.left + container.scrollLeft,
        y: itemRect.top - containerRect.top + container.scrollTop,
        width: itemRect.width,
        height: itemRect.height
      };
    }
  }, {
    key: "getContentSize",
    value: function getContentSize() {
      var container = this.ref.current;

      var _container_scrollWidth, _container_scrollHeight;

      return {
        width: (_container_scrollWidth = container === null || container === void 0 ? void 0 : container.scrollWidth) !== null && _container_scrollWidth !== void 0 ? _container_scrollWidth : 0,
        height: (_container_scrollHeight = container === null || container === void 0 ? void 0 : container.scrollHeight) !== null && _container_scrollHeight !== void 0 ? _container_scrollHeight : 0
      };
    }
  }, {
    key: "getVisibleRect",
    value: function getVisibleRect() {
      var container = this.ref.current;

      var _container_scrollLeft, _container_scrollTop, _container_offsetWidth, _container_offsetHeight;

      return {
        x: (_container_scrollLeft = container === null || container === void 0 ? void 0 : container.scrollLeft) !== null && _container_scrollLeft !== void 0 ? _container_scrollLeft : 0,
        y: (_container_scrollTop = container === null || container === void 0 ? void 0 : container.scrollTop) !== null && _container_scrollTop !== void 0 ? _container_scrollTop : 0,
        width: (_container_offsetWidth = container === null || container === void 0 ? void 0 : container.offsetWidth) !== null && _container_offsetWidth !== void 0 ? _container_offsetWidth : 0,
        height: (_container_offsetHeight = container === null || container === void 0 ? void 0 : container.offsetHeight) !== null && _container_offsetHeight !== void 0 ? _container_offsetHeight : 0
      };
    }
  }]);
}();

export { $657e4dc4a6e88df0$export$8f5ed9ff9f511381 as DOMLayoutDelegate };